import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FloatingSidebar from '@/components/feature/FloatingSidebar';
import { initNewtranx } from '@/lib/newtranx';

function Layout() {
  useEffect(() => {
    initNewtranx();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingSidebar />
    </div>
  );
}

export default Layout;